import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { OrderComponent } from "../../order-manager/order/order.component";
import dayjs from "dayjs";

@Component({
    selector: 'app-submit-to-sap',
    templateUrl: './submit-to-sap.component.html',
    styleUrls: ['./submit-to-sap.component.css'],
    standalone: false
})
export class SubmitToSapComponent implements OnInit {

    orderNumber = this.data.orderId;
    orderDate = this.data.orderDate;
    compareOrderDate = dayjs(this.data.orderDate);
    currentDate = dayjs();
    isOrderDateExpired: boolean = false;

    placeholder = '-';
    dateStringFormatting = 'DD.MM.YYYY';
    orderDateExpired: string;

    inDiscountLev =   this.data.inDiscountLev;
    totalDisc =  this.data.totalDisc;
    termDaysExceed = this.data.termsExceeded;
    approvalRequiredDisplay: string;
    isOutsideDiscountLev: boolean;
    isTermExceeded: boolean;
    approvalRequired: boolean;


    protected readonly dayjs = dayjs;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<OrderComponent>    ) {}

    ngOnInit(): void {

        if(this.inDiscountLev === 'YES'){
            this.isOutsideDiscountLev = true;
        }else{
            this.approvalRequired = true;
            this.isOutsideDiscountLev = false;
        }

        if(this.termDaysExceed === 'YES'){
            this.isTermExceeded = true;
        }else{
            this.isTermExceeded = false;
        }

        const thirtyDaysAgo = this.currentDate.subtract(30, 'day');
        if (this.compareOrderDate.isBefore(thirtyDaysAgo)) {
            this.isOrderDateExpired = true;
            this.orderDateExpired = 'YES';
        }else{
            this.isOrderDateExpired = false;
            this.orderDateExpired = 'NO';
        }


        if(this.termDaysExceed === 'YES' || this.isOutsideDiscountLev === true ||  this.isOrderDateExpired == true || this.compareOrderDate.isBefore(thirtyDaysAgo)){
            this.approvalRequired = true;
            this.approvalRequiredDisplay = 'YES'
        }else{
            this.approvalRequired = false;
            this.approvalRequiredDisplay = 'NO'
        }
    }

    cancelSubmitToSap() {
        this.dialogRef.close(false);
    }
    triggerSubmitToSap() {
        let submitObject = {
            isSubmit: true,
            discountLevel:this.isOutsideDiscountLev,
            termDaysExceed: this.isTermExceeded,
            isOrderDateExpired:this.isOrderDateExpired,
        }
        this.dialogRef.close(submitObject);
    }
}
